module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Headphones-a8dd3601fe6d6d02eeb0ede331041cd5.svg";